import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { noun } from 'plural-ru';
import uniqueId from 'lodash/uniqueId';
import moment from 'moment';

import {
  getAvailableAppealDeadline,
  isAppealNotStarted,
} from '../../services/getAvailableAppealDeadline';

import './SubjectsInfo.pcss';
import { DATE_FORMAT } from '../../helpers/date';

const INFO_CLASSNAMES = {
  plain: 'StepGia__subjectsInfo__item_plain',
  possible: 'StepGia__subjectsInfo__item_possible',
  unavailable: 'StepGia__subjectsInfo__item_unavailable',
  expired: 'StepGia__subjectsInfo__item_expired',
};

const INFO_WORDS = {
  possible: 'Подача апелляции возможна',
  unavailable: 'Возможность подачи апелляции еще не открыта',
  expired: 'Сроки подачи апелляций истекли',
};

const getClassName = (subject) => {
  if (isAppealNotStarted(subject)) {
    return cn('StepGia__subjectsInfo__item', INFO_CLASSNAMES.unavailable);
  }

  if (getAvailableAppealDeadline(subject)) {
    return cn('StepGia__subjectsInfo__item', INFO_CLASSNAMES.possible);
  }

  return cn('StepGia__subjectsInfo__item', INFO_CLASSNAMES.expired);
};

const getWord = (subject) => {
  if (isAppealNotStarted(subject)) {
    return INFO_WORDS.unavailable;
  }

  if (getAvailableAppealDeadline(subject)) {
    return INFO_WORDS.possible;
  }

  return INFO_WORDS.expired;
};

const getDate = (subject) => {
  const {
    appeal_start_date_formatted,
    appeal_end_date_formatted,
    appeal_start_date2_formatted,
    appeal_end_date2_formatted,
  } = subject;

  const hasSecondDate =
    !!appeal_start_date2_formatted && !!appeal_end_date2_formatted;

  const isSameFirstDate = moment(
    appeal_start_date_formatted,
    DATE_FORMAT,
  ).isSame(moment(appeal_end_date_formatted, DATE_FORMAT), 'day');
  const isSameSecondDate =
    hasSecondDate &&
    moment(appeal_start_date2_formatted, DATE_FORMAT).isSame(
      moment(appeal_end_date2_formatted, DATE_FORMAT),
      'day',
    );

  const getDateString = (isSame, dateStart, dateEnd, hasComma) => {
    if (isSame) {
      return `${dateStart}${hasComma ? ', ' : ''}`;
    }

    return `${dateStart} – ${dateEnd}${hasComma ? ', ' : ''}`;
  };

  const firstDate = getDateString(
    isSameFirstDate,
    appeal_start_date_formatted,
    appeal_end_date_formatted,
    hasSecondDate,
  );
  const secondDate = hasSecondDate
    ? getDateString(
        isSameSecondDate,
        appeal_start_date2_formatted,
        appeal_end_date2_formatted,
        false,
      )
    : '';

  const multipleString =
    hasSecondDate && !(isSameFirstDate && isSameSecondDate);

  if (multipleString) {
    return (
      <>
        <div>{firstDate}</div>
        <div>{secondDate}</div>
      </>
    );
  }

  return (
    <div>
      {firstDate}
      {secondDate}
    </div>
  );
};

const SubjectsInfo = ({ subjectsInfo }) => (
  <div className="StepGia__subjectsInfo">
    <h2 className="StepGia__subjectsInfo__title">График подачи апелляций</h2>
    <div className="StepGia__subjectsInfo__items">
      <div className="StepGia__subjectsInfo__header">
        <div>Наименование предмета</div>
        <div>Дата экзамена</div>
        <div>Даты подачи апелляции</div>
      </div>
      {subjectsInfo.map((subject) => (
        <div className={getClassName(subject)} key={uniqueId('subject-')}>
          <div className="StepGia__subjectsInfo__data">
            <div>
              <div>
                {`${subject.subject_name} – ${subject.score} ${noun(
                  subject.score,
                  'балл',
                  'балла',
                  'баллов',
                )}`}
              </div>
              <div className="StepGia__subjectsInfo__item__possibility">
                {getWord(subject)}
              </div>
            </div>
            <div className="StepGia__subjectsInfo__data__mobile">
              Дата экзамена
            </div>
            <div>{subject.date_formatted}</div>
            <div className="StepGia__subjectsInfo__data__mobile">
              Даты подачи апелляции
            </div>
            <div>{getDate(subject)}</div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

SubjectsInfo.propTypes = {
  subjectsInfo: PropTypes.array,
};

export default SubjectsInfo;
